import React, { useRef, useState } from "react"
import styled from "@emotion/native"
import { Dimensions, TextInputInstance, View } from "react-native"
import { InputErrorMessage } from "../ui-components"

const TextInputHidden = styled.TextInput`
  position: absolute;
  opacity: 0;
`

const SplitOTPBoxesContainer = styled.Pressable`
  flex-direction: row;
  gap: 8px;
`
const SplitBoxes = styled.View`
  border-radius: 14px;
  min-width: ${() => Math.min(Dimensions.get("window").width - 80, 420) / 6 + "px"};
  min-height: 54px;
  background-color: ${({ theme }) => theme.otpBox.backgroundColor};
  align-items: center;
  justify-content: center;
`

const SplitBoxText = styled.Text`
  font-size: 20px;
  text-align: center;
  color: ${({ theme }) => theme.otpBox.textColor};
`

const SplitBoxesFocused = styled(SplitBoxes)`
  background-color: ${({ theme }) => theme.otpBox.backgroundColor};
  border-color: ${({ theme }) => theme.otpBox.focusedBorderColor};
  border-width: 1px;
`

type OTPInputProps = {
  code: string
  setCode: (c: string) => void
  errorMessage?: string
  onProceed: (otpCode: string) => void
}

const MAX_LENGTH = 6

export const OTPInputV2 = ({ code, setCode, errorMessage, onProceed }: OTPInputProps) => {
  const boxArray = new Array(MAX_LENGTH).fill(0)
  const inputRef = useRef<TextInputInstance>(null)

  const [isInputBoxFocused, setIsInputBoxFocused] = useState(false)

  const handleOnPress = () => {
    setIsInputBoxFocused(true)
    if (!inputRef.current) {
      return
    }
    inputRef.current.focus()
  }

  const handleOnBlur = () => {
    setIsInputBoxFocused(false)
  }

  const handleChangeText = (otpCode: string) => {
    setCode(otpCode)
    if (otpCode.length >= MAX_LENGTH) {
      onProceed(otpCode)
    }
  }

  const boxDigit = (_: number, index: number) => {
    const emptyInput = ""
    const digit = code[index] || emptyInput

    const isCurrentValue = index === code.length
    const isLastValue = index === MAX_LENGTH - 1
    const isCodeComplete = code.length === MAX_LENGTH

    const isValueFocused = isCurrentValue || (isLastValue && isCodeComplete)

    const StyledSplitBoxes = isInputBoxFocused && isValueFocused ? SplitBoxesFocused : SplitBoxes
    return (
      <StyledSplitBoxes key={index} testID={`otpBox${index}`}>
        <SplitBoxText>{digit}</SplitBoxText>
      </StyledSplitBoxes>
    )
  }

  return (
    <View>
      <SplitOTPBoxesContainer onPress={handleOnPress} testID="otpInputContainer">
        {boxArray.map(boxDigit)}
      </SplitOTPBoxesContainer>
      {!!errorMessage && <InputErrorMessage message={errorMessage} />}
      <TextInputHidden
        value={code}
        onChangeText={handleChangeText}
        maxLength={MAX_LENGTH}
        ref={inputRef}
        onBlur={handleOnBlur}
        keyboardType="numeric"
        testID="OTPInput"
        autoFocus
      />
    </View>
  )
}
